/* eslint-disable no-plusplus */
let traceId = '0';
if (typeof window !== 'undefined' && window.crypto && window.crypto.randomUUID) {
  traceId = window.crypto.randomUUID().split('-').join('');
}
let spanId = 0;
export const getClientTraceId = () => {
  return `${traceId}/${spanId++}`;
};